import { useGetAutomationConfigQuery } from 'automations/services/automationConfigService';

export const useConfig = () => {
  const configData = useGetAutomationConfigQuery();

  return {
    triggers: configData.data?.triggers,
    conditions: configData.data?.conditions,
    actions: configData.data?.actions,
    ...configData,
  };
};
